import { Sheet, SheetContent, SheetTitle } from "@/components/ui/sheet";
import { SocialTopicView, SocialTopicViewProps } from "./SocialTopicView";

interface SocialUniverseDrawerProps
  extends Omit<
    SocialTopicViewProps,
    "universeToken" | "layout" | "headerLeading" | "renderTitle"
  > {
  /** Opens the drawer; null closes it. */
  universeToken: string | null;
}

/**
 * The Topic view in a right-hand sheet, for the back office, which opens a
 * Topic from its own state rather than the Topic page.
 */
export function SocialUniverseDrawer(props: SocialUniverseDrawerProps) {
  const { universeToken, onClose, ...viewProps } = props;

  return (
    <Sheet
      open={universeToken != null}
      onOpenChange={(open) => {
        if (!open) {
          onClose();
        }
      }}
    >
      <SheetContent
        side="right"
        className="flex w-full flex-col gap-0 overflow-y-auto p-0 sm:max-w-[820px]"
        aria-describedby={undefined}
        data-testid="social-universe-drawer"
      >
        {universeToken ? (
          <SocialTopicView
            {...viewProps}
            universeToken={universeToken}
            layout="sheet"
            renderTitle={(title, className) => (
              <SheetTitle className={className}>{title}</SheetTitle>
            )}
            onClose={onClose}
          />
        ) : null}
      </SheetContent>
    </Sheet>
  );
}
